import React, { useState, useEffect } from 'react';
import { Box, Button, TextField, Typography, Paper, Stack } from '@mui/material';
import { useNotification } from '../providers/NotificationProvider';
import axios from 'axios';
import { getApiUrl } from '../config/api';
import { cacheClearAll } from '../services/cacheManager';
import { fetchContentVersion, setContentVersionForSession } from '../services/contentVersion';

const CacheRefreshManual: React.FC = () => {
  const { showSuccess, showError } = useNotification();
  const [token, setToken] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    // Pre-fill from URL query if present
    try {
      const params = new URLSearchParams(window.location.search);
      const t = params.get('token');
      if (t) setToken(t);
    } catch {}
  }, []);

  const handleSubmit = async (e?: React.FormEvent) => {
    e?.preventDefault();
    if (!token) {
      showError('Enter token');
      return;
    }
    setLoading(true);
    try {
      // Send manual invalidate
      await axios.post(getApiUrl('cache/invalidate/manual'), {}, {
        headers: { 'X-Manual-Token': token }
      });

      // Clear local cache immediately and refresh version
      await cacheClearAll();
      const v = await fetchContentVersion();
      if (v) {
        sessionStorage.setItem('contentVersion', String(v.version));
        setContentVersionForSession(v);
      }

      showSuccess('Cache invalidated');
    } catch (err: any) {
      const msg = err?.response?.data?.error || err?.message || 'Failed to invalidate cache';
      showError(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ display: 'flex', height: '100vh', justifyContent: 'center', alignItems: 'center' }}>
      <Paper sx={{ p: 3, maxWidth: 480, width: '100%' }}>
        <Stack spacing={2} component="form" onSubmit={handleSubmit}>
          <Typography variant="h6">Manual Cache Refresh</Typography>
          <Typography variant="body2" color="text.secondary">
            Paste the manual token and click Refresh. You can also provide it via ?token= in the URL.
          </Typography>
          <TextField
            label="Manual token"
            value={token}
            onChange={(e) => setToken(e.target.value)}
            autoComplete="off"
            fullWidth
          />
          <Button variant="contained" type="submit" disabled={loading}>
            {loading ? 'Refreshing…' : 'Refresh cache'}
          </Button>
        </Stack>
      </Paper>
    </Box>
  );
};

export default CacheRefreshManual;
